import { resolveProductImageUrl } from '@/entities/product/lib/resolveProductImages'
import { mapNullableNonNegInt, mapOptionalTrimmedString } from '@/shared/lib/mapApiScalars'

export function mapBasketModifier(raw) {
  return {
    groupId: String(raw?.group_id ?? ''),
    groupTitle: String(raw?.group_title ?? ''),
    optionId: String(raw?.option_id ?? ''),
    title: String(raw?.title ?? ''),
    priceDelta: Number(raw?.price_delta) || 0,
  }
}

export function mapBasketModifiers(rawModifiers) {
  if (!Array.isArray(rawModifiers)) {
    return []
  }
  return rawModifiers
    .map(mapBasketModifier)
    .filter((item) => item.optionId || item.title)
}

export function mapBasketItem(raw) {
  const productId = String(raw.product_id ?? '')
  const modifiers = mapBasketModifiers(raw.modifiers)

  return {
    id: productId,
    lineKey: String(raw.line_key ?? productId),
    title: String(raw.title ?? ''),
    price: Number(raw.price) || 0,
    basePrice:
      raw.base_price != null && Number.isFinite(Number(raw.base_price))
        ? Number(raw.base_price)
        : Number(raw.price) || 0,
    currency: 'VND',
    weightGrams: null,
    imageUrl: resolveProductImageUrl(raw),
    compareAtPrice:
      raw.compare_at_price != null && Number.isFinite(Number(raw.compare_at_price))
        ? Number(raw.compare_at_price)
        : null,
    quantity: Math.max(1, Math.floor(Number(raw.quantity) || 1)),
    modifiers,
    maxQuantity: mapNullableNonNegInt(raw, 'max_quantity'),
    available: raw.available !== false,
    unavailableMessage: mapOptionalTrimmedString(raw.unavailable_message),
  }
}
